export class TextUtils {
	static isEmpty(text: string): boolean {
		return typeof text === 'undefined' || text === null || text.length === 0;
	}
}